module.exports = __webpack_public_path__ + "assets/align_center.2015a6d8.svg";